import { StandardTextFieldProps } from '@mui/material';
import cn from 'classnames';
import { forwardRef } from 'react';

import { FieldCustom } from './FieldCutom';
import styles from './Form.module.sass';
import { IField } from './form-element.inrerface';

const Field = forwardRef<HTMLInputElement, IField & StandardTextFieldProps>(
  ({ title, label, error, type = 'text', style, ...rest }, ref) => {
    return (
      <div className={styles.wrapper}>
        <FieldCustom
          ref={ref}
          {...rest}
          className={cn(styles.common, styles.field)}
          id="standard-basic"
          label={label}
          variant="standard"
          error={!!error?.message}
          type="text"
        />
        {error && <div className={styles.error}>{error.message}</div>}
      </div>
    );
  }
);

Field.displayName = 'Field';

export default Field;
